export default __webpack_public_path__ + "static/media/placeholder_private03-nl-mobile.3a85ca91.png";